import { useState } from 'react';
import axios from 'axios';

const useAccountingApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = 'v1';

  const handleApiError = async (response) => {
    const contentType = response.headers.get('content-type');
    try {
      if (contentType?.includes('application/json')) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Server error: ${response.status}`);
      } else {
        const errorText = await response.text();
        throw new Error(errorText || `Network error: ${response.status}`);
      }
    } catch (err) {
      throw new Error(`Request failed: ${err.message}`);
    }
  };

  const fetchWithRetry = async (url, config, retries = 2) => {
    for (let i = 0; i <= retries; i++) {
      try {
        console.log(`Attempt ${i + 1} - Sending request to:`, url);
        const response = await fetch(url, config);
        
        if (!response.ok) {
          await handleApiError(response);
        }
        return response;
      } catch (err) {
        console.error(`Attempt ${i + 1} failed:`, err);
        if (i === retries) throw err;
        await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
      }
    }
  };

  const getSuggestion = async (data) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/accounting/suggest`, data);
      
      const suggestion = response.data;
      
      const parsedResult = {
        debit_accounts: suggestion.debit_accounts.map(account => ({
          name: account,
          amount: '',
          description: ''
        })),
        credit_accounts: suggestion.credit_accounts.map(account => ({
          name: account,
          amount: '',
          description: ''
        })),
        explanation: suggestion.reason || '',
        cautions: suggestion.caution ? [suggestion.caution] : [],
        taxConsiderations: suggestion.tax_implications ? [suggestion.tax_implications] : []
      };

      setLoading(false);
      return parsedResult;
    } catch (err) {
      console.error('API Error:', err);
      setError(err.response?.data?.message || '분개 추천을 가져오는데 실패했습니다.');
      setLoading(false);
      throw err;
    }
  };

  const submitFeedback = async (data) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/accounting/feedback`, data);
    } catch (err) {
      console.error('Feedback submission error:', err);
    }
  };

  const formatAmount = (value) => {
    const numbers = value.replace(/[^0-9]/g, '');
    return numbers ? parseInt(numbers).toLocaleString() : '';
  };

  const clearError = () => setError(null);

  return {
    loading,
    error,
    getSuggestion,
    submitFeedback,
    formatAmount,
    clearError
  };
};

export default useAccountingApi;